<p-button
  *ngIf="action"
  [styleClass]="'p-button-rounded p-button-icon-only' + size"
  (onClick)="onClick()"
  [ngClass]="action + ' ' + size"
  ><i class="material-icons">{{ action }}</i></p-button
>
